<h1 mat-dialog-title>
  {{ 'Seleziona collezione' | translate }}
</h1>

<form
  class="new-collection-container"
  #newCollectionFormDirective="ngForm"
  [formGroup]="newCollectionForm"
  (ngSubmit)="addCollectionHandler()">
  <mat-form-field
    appearance="outline"
    class="input-expanse input-container-no-padding">
    <mat-label>Crea collezione</mat-label>
    <input
      matInput
      formControlName="titolo"
      placeholder="Inserisci il nome di una nuova collezione"
      type="text">
  </mat-form-field>
  <button
    mat-icon-button
    type="submit"
    [disabled]="!newCollectionForm.value.titolo">
    <mat-icon>add</mat-icon>
  </button>
</form>

<ui-filters
  [dialogFilters]="MobileFiltersComponent"
  [showFiltersTitle]="false"
  (action)="applyFilterWithDelayHandler($event)">
  <app-collection-filters #desktopFilter></app-collection-filters>
</ui-filters>

<ng-container *ngIf="collectionPage$ | async as collectionPage; else loading">
  <mat-dialog-content>
    <mat-selection-list (selectionChange)="toggleCollectionHandler($event)">
      <mat-list-option
        *ngFor="let collection of collectionPage.data"
        [selected]="isCollectionSelected(collection)"
        [value]="collection">
        {{ collection.titolo }}
      </mat-list-option>
    </mat-selection-list>
  </mat-dialog-content>
  <mat-paginator
    [length]="collectionPage?.count"
    [pageSize]="collectionPage?.params?.limit"
    [pageSizeOptions]="pageSizeOptions"
    (page)="changePageHandler($event)">
  </mat-paginator>
</ng-container>

<ng-template #loading>
  <div class="collection-loading-container">
    <ngx-spinner
      [fullScreen]="false"
      name="loadingCollection"
      type="square-loader"
      size="medium"
      class="loading-spinner">
    </ngx-spinner>
  </div>
</ng-template>

<mat-dialog-actions class="collection-actions">
  <div>
    <button
      mat-button
      mat-raised-button
      type="button"
      (click)="closeHandler()">
      {{ 'Annulla' | translate }}
    </button>
    <button
      mat-button
      mat-raised-button
      color="primary"
      type="button"
      (click)="saveHandler()">
      {{ 'Aggiungi' | translate }}
    </button>
  </div>
</mat-dialog-actions>
